import { styled } from '@uhg-abyss/web/tools/styled';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Text } from '@uhg-abyss/web/ui/Text';

export const ErrorHandlingContainer = styled('div', {
  height: '500px',
});

export const UnableToLoadPlanHeading = styled(Heading, {
  color: '$core.color.brand.100',
  fontFamily: '$heading',
  fontSize: '36.49px !important',
  fontWeight: '600',
  lineHeight: '44px !important',
  padding: '79px 0px 0px 80px',
});

export const UnableToLoadPlanText = styled(Text, {
  display: 'block',
  fontSize: '16px',
  fontWeight: '500',
  lineHeight: '20px',
  padding: '16px 0px 0px 80px',
});

export const goToUhcButtonStyles = {
  margin: '28px 0px 0px 78px',
};
